var map = {
	"../pages/admin-clinics-add/admin-clinics-add.module": [
		464
	],
	"../pages/admin-clinics/admin-clinics.module": [
		309
	],
	"../pages/admin-nursinghome/admin-nursinghome.module": [
		467
	],
	"../pages/admin-orders/admin-orders.module": [
		465
	],
	"../pages/admin-prescriptions-note/admin-prescriptions-note.module": [
		469
	],
	"../pages/admin-prescriptions/admin-prescriptions.module": [
		470
	],
	"../pages/admin-supplies-add/admin-supplies-add.module": [
		471
	],
	"../pages/admin-supplies-upload/admin-supplies-upload.module": [
		473
	],
	"../pages/admin-supplies/admin-supplies.module": [
		477
	],
	"../pages/admin-users-add/admin-users-add.module": [
		475
	],
	"../pages/admin-users/admin-users.module": [
		479
	],
	"../pages/admin-utility/admin-utility.module": [
		481
	],
	"../pages/clinic-doctors-add/clinic-doctors-add.module": [
		486
	],
	"../pages/clinic-doctors/clinic-doctors.module": [
		488
	],
	"../pages/clinic-supplies-default/clinic-supplies-default.module": [
		490
	],
	"../pages/groups-add/groups-add.module": [
		491
	],
	"../pages/groups/groups.module": [
		493
	],
	"../pages/home/home.module": [
		495
	],
	"../pages/login/login.module": [
		497
	],
	"../pages/order-details/order-details.module": [
		499
	],
	"../pages/orders/orders.module": [
		500
	],
	"../pages/patient-add/patient-add.module": [
		502
	],
	"../pages/patient-batch/patient-batch.module": [
		513
	],
	"../pages/patient-details/patient-details.module": [
		514
	],
	"../pages/patient-upload/patient-upload.module": [
		515
	],
	"../pages/patients/patients.module": [
		516
	],
	"../pages/reports/reports.module": [
		517
	],
	"../pages/supplies/supplies.module": [
		527
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 308;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 308
// module chunks = 0